import { SUBJECTS_TICKER } from "../../data/content";

export const Ticker = () => {
    const items = [...SUBJECTS_TICKER, ...SUBJECTS_TICKER];
    return (
        <div
            data-testid="subjects-ticker"
            className="bg-ink text-bone overflow-hidden py-5 border-y border-ink"
        >
            <div className="animate-marquee flex whitespace-nowrap w-max">
                {items.map((s, i) => (
                    <span key={i} className="flex items-center">
                        <span className="font-serif italic text-xl md:text-2xl px-8">{s}</span>
                        <span className="w-1.5 h-1.5 rotate-45 bg-oxblood inline-block" />
                    </span>
                ))}
            </div>
        </div>
    );
};
